// 流程步骤
<template>
  <div class="step">
    <ul
      class="nav"
      :class="['nav'+step]"
      :style="{backgroundPositionY: -0.96 * (index-1) + 'rem'}">
      <li class="li" :class="{active :navIndex+1 == index}" v-for="(navItme, navIndex) in list" :key="navItme">{{navIndex+1}}.{{navItme}}</li>
    </ul>
  </div>
</template>

<script>
var vm 
export default {
  name: 'expressSaveFlow',
  // props: ['index', 'step'],
  data () {
    return {
      list: [],
      navList2: ['登录', '打开箱子'],
      navList3: ['选择箱格大小', '登录', '打开箱子'],
      step: 0,
      index: 0
    }
  },
  created () {
    vm = this
    this.step = vm.$store.state.officeLocker_stepInfo.step
    this.index = vm.$store.state.officeLocker_stepInfo.index
    this.list = this['navList'+this.step]
    // console.log('tag', this.step)
  },
  destroyed () {
    // console.log('step摧毁', '')
    // vm.$store.state.officeLocker_stepInfo = {}
  },
  watch: {
  }
}
  
</script>

<style lang="less">
.step {
  text-align: center;
  .nav.nav3 {
    width: 10.69rem;
    background-image: url(../../../../../static/officeLocker/images/step3.png);
    background-repeat: no-repeat;
    background-position-x: 0;
    background-size: 10.69rem 2.88rem;
    .li {
      width: 33.33%;
    }
  }
  .nav.nav2 {
    width: 7.62rem;
    background-image: url(../../../../../static/officeLocker/images/step2.png);
    background-repeat: no-repeat;
    background-position-x: 0;
    background-size: 7.62rem 1.92rem;
    .li {
      width: 50%;
    }
  }
  .nav{
    margin:  0 auto;
    height: 0.96rem;
    line-height: 0.96rem;
    display: flex;
    .li {
      font-size: 0.34rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/officeLocker/page/module/step.vue